import { render } from "./PosListItem.vue?vue&type=template&id=2b016222&scoped=true"
import script from "./PosListItem.vue?vue&type=script&lang=js"
export * from "./PosListItem.vue?vue&type=script&lang=js"

import "./PosListItem.vue?vue&type=style&index=0&id=2b016222&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b016222"

export default script